import { For, type JSX } from 'solid-js'
import type { ViewProps } from 'wdc-cube-solid'
import type { AppDeleteAccountScope } from 'mormaii-web-presentation/app-delete-account'

import { Brand } from '../../components/icons'

import Css from './account.module.scss'

/**
 * O passo a passo para excluir a conta pelo app.
 *
 * Nao usa a moldura de conta: aqui nao se entra em lugar algum, se LE. E a pagina
 * que as lojas (App Store e Play Store) apontam, entao ela precisa abrir sozinha,
 * sem sessao e sem nada a preencher.
 *
 * O texto todo vem do scope - ver o comentario la sobre por que.
 */
export function AppDeleteAccountView(props: ViewProps<AppDeleteAccountScope>): JSX.Element {
    return (
        <div class={Css.page}>
            <header class={Css.top}>
                <div class={Css.brand}>
                    <Brand class={Css.brandIcon} />
                    <span class={Css.brandName}>
                        Mormaii <span class={Css.brandAccent}>Mais Saúde</span>
                    </span>
                </div>
            </header>

            <main class={Css.body}>
                <div class={Css.panel}>
                    <div class={Css.texts}>
                        <h1 class={Css.title}>{props.scope.title}</h1>
                        <p class={Css.subtitle}>{props.scope.subtitle}</p>
                    </div>

                    <ol class={Css.steps}>
                        <For each={props.scope.steps}>
                            {(step, index) => (
                                <li class={Css.step}>
                                    <span class={Css.stepNumber}>{index() + 1}</span>
                                    <span class={Css.stepText}>{step}</span>
                                </li>
                            )}
                        </For>
                    </ol>
                </div>
            </main>
        </div>
    )
}
